import { motion } from "framer-motion";
import { IMAGES } from "@/constants/site";
import { useSiteImage } from "@/context/ImagesContext";

const EASE = [0.22, 1, 0.36, 1];

const Story = () => {
  const storySrc = useSiteImage("story", IMAGES.story.url);

  return (
    <section id="story" data-testid="our-story-section" className="py-24 sm:py-32 lg:py-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-20 items-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: EASE }}
          className="lg:col-span-5"
        >
          <div className="relative">
            <div className="absolute -top-4 -left-4 w-full h-full border border-gold/60 rounded-sm" aria-hidden="true" />
            <div className="relative overflow-hidden rounded-sm shadow-2xl shadow-espresso/20">
              <img
                src={storySrc}
                alt={IMAGES.story.alt}
                loading="lazy"
                className="w-full aspect-[4/5] object-cover hover:scale-105 transition-transform duration-[1.4s] ease-out"
              />
            </div>
            <p className="mt-5 font-mono-alt text-[10px] tracking-[0.25em] uppercase text-muted-brand">
              The estate, from above · Sakleshpur
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, delay: 0.15, ease: EASE }}
          className="lg:col-span-7"
        >
          <p className="eyebrow mb-6">Our Story</p>
          <h2 className="font-display font-normal text-espresso text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight">
            The land remembers
            <span className="italic text-forest"> every hand </span>
            that has tended it.
          </h2>
          <div className="mt-8 space-y-6 text-muted-brand text-base sm:text-lg leading-relaxed max-w-xl">
            <p>
              For over 180 years, our family has walked these hills. Generation after generation, the same
              slopes, the same mist, the same patient work.
            </p>
            <p>
              We have never hurried the land. Tradition and nature grow side by side here — the old ways kept,
              the forest left standing, the crops given time.
            </p>
            <p>
              What Masthare offers is not produced. It is inherited, tended, and passed on.
            </p>
          </div>
          <p className="mt-10 font-display italic text-xl text-coffee">— The Masthare Family</p>
        </motion.div>
      </div>
    </section>
  );
};

export default Story;
